import { SET_PROFILE_PRODUCT, SET_PROFILE_PRODUCT_SHARE, GET_PROFILE_PRODUCT_SHARES, GET_PRODUCTS, LOGOUT } from './types';
import api from "../utils/api";


export const list = ({ category = "ALL", frequency = "ALL", area = "X"}) => async (dispatch) => {
    try {
        // /df/:dateFrom/dt/:dateTo/a/:assignedToUuid/e/:eventUuid
        const res = await api.get(`/products/l/c/${category}/f/${frequency}/a/${area}`);

        if (res?.data) {
            dispatch({
                type: GET_PRODUCTS,
                payload: res.data
            });
        }
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
};

export const catalog = () => async () => {
    try {
        const res = await api.get("/products/catalog");
        return res.data;
    } catch (err) {
        return {
            success: false,
            error: err?.response?.data?.error || {
                message: "Products could not be loaded. Try again."
            }
        };
    }
};

export const sourceList = ({ page = 0, size = 25, order = "name", direction = "ASC", raw = 1, search = ""}) => async (dispatch) => {
    try {
        const url = `/products/settings/p/${page}/s/${size}/o/${order}/${direction}/${raw}${search ? `/${search}` : ""}`;
        const res = await api.get(url);
        return res.data;
    } catch (err) {
        console.error("Unable to load license products.", {
            status: err?.response?.status,
            data: err?.response?.data,
            url: err?.config?.url,
        });
        return [];
    }
};

export const sourceGet = ({ uuid }) => async (dispatch) => {
    try {
        const res = await api.get(`/products/settings/${uuid}`);
        return res.data;
    } catch (err) {
        console.error("Unable to load owned license products.", {
            status: err?.response?.status,
            data: err?.response?.data,
            url: err?.config?.url,
        });
        return [];
    }
};

export const sourceSave = (payload) => async (dispatch) => {
    try {
        const res = await api.post(`/products/settings`, payload);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
};

export const sourceDestroy = ({ uuid }) => async (dispatch) => {
    try {
        const res = await api.delete(`/products/settings/${uuid}`);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
};

export const mine = ({ uuid = "X", category = "ALL", frequency = "ALL", area = "X", page = 0, size = 25, order = "Product.Code.description", direction = "ASC", raw = 1, search = ""}) => async (dispatch) => {
    try {
        // /df/:dateFrom/dt/:dateTo/a/:assignedToUuid/e/:eventUuid
        const res = await api.get(`/products/me/l/c/${category}/f/${frequency}/a/${area}/i/${uuid}/p/${page}/s/${size}/o/${order}/${direction}/${raw}/${search}`);
        return Array.isArray(res.data) ? res.data : (res.data?.rows || []);
    } catch (err) {
        console.error("Unable to load owned license products.", {
            status: err?.response?.status,
            data: err?.response?.data,
            url: err?.config?.url,
        });
        return [];
    }
};

export const changes = ({ uuid = "X", category = "ALL", frequency = "ALL", area = "X", page = 0, size = 25, order = "Product.Code.description", direction = "ASC", raw = 1, search = "", omit = []}) => async (dispatch) => {
    try {
        let query_string = "";
        if (omit.length > 0) {
            query_string += "?ns=" + omit.join("&ns=");
        }

        // /df/:dateFrom/dt/:dateTo/a/:assignedToUuid/e/:eventUuid
        const res = await api.get(`/changes/me/l/c/${category}/f/${frequency}/a/${area}/i/${uuid}/p/${page}/s/${size}/o/${order}/${direction}/${raw}/${search}${query_string}`);
        return Array.isArray(res.data) ? res.data : (res.data?.rows || []);
    } catch (err) {
        console.error("Unable to load license changes.", {
            status: err?.response?.status,
            data: err?.response?.data,
            url: err?.config?.url,
        });
        return [];
    }
};

export const orders = ({ uuid = "X", category = "ALL", frequency = "ALL", area = "X", page = 0, size = 25, order = "Product.Code.description", direction = "ASC", raw = 1, search = "", statuses = []}) => async (dispatch) => {
    try {
        const query = [];
        (statuses || []).forEach((status) => {
            if (status) query.push(`status=${encodeURIComponent(status)}`);
        });

        const queryString = query.length > 0 ? `?${query.join("&")}` : "";
        const encodedSearch = encodeURIComponent(search || "");
        const res = await api.get(`/changes/orders/l/c/${category}/f/${frequency}/a/${area}/i/${uuid}/p/${page}/s/${size}/o/${order}/${direction}/${raw}/${encodedSearch}${queryString}`);
        return Array.isArray(res.data) ? res.data : (res.data?.rows || []);
    } catch (err) {
        console.error("Unable to load license orders.", {
            status: err?.response?.status,
            data: err?.response?.data,
            url: err?.config?.url,
        });
        return [];
    }
};

export const finances = ({ uuid }) => async (dispatch) => {
    try {
        // /df/:dateFrom/dt/:dateTo/a/:assignedToUuid/e/:eventUuid
        const res = await api.get(`/products/me/invoices/s/u/${uuid}`);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const save = ({ uuid, key = null }) => async (dispatch) => {
    try {
        // /df/:dateFrom/dt/:dateTo/a/:assignedToUuid/e/:eventUuid
        const res = await api.put(`/products/me`, { uuid, key });

        if (res?.data) {
            dispatch({
                type: SET_PROFILE_PRODUCT,
                payload: res.data
            });
        }
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
};

export const destroyMine = ({ uuid, retentionPolicyKey = "default" }) => async () => {
    try {
        const res = await api.delete(`/products/me/${encodeURIComponent(uuid)}`, {
            data: { retentionPolicyKey }
        });
        return res.data;
    } catch (err) {
        return {
            success: false,
            error: err?.response?.data?.error || {
                message: "Unable to delete this product."
            }
        };
    }
};

export const lifecycle = ({ uuid }) => async () => {
    try {
        const res = await api.get(`/products/me/${encodeURIComponent(uuid)}/lifecycle`);
        return res.data;
    } catch (err) {
        return {
            success: false,
            error: err?.response?.data?.error || { message: "Unable to load product setup." }
        };
    }
};

export const tokenizeProduct = ({ uuid }) => async () => {
    try {
        const res = await api.post(`/products/me/${encodeURIComponent(uuid)}/tokenize`);
        return res.data;
    } catch (err) {
        return {
            success: false,
            error: err?.response?.data?.error || { message: "Unable to open this product." }
        };
    }
};

export const saveLifecycleSettings = ({ uuid, sectionKey, values, expectedRevision }) => async () => {
    try {
        const res = await api.put(`/products/me/${encodeURIComponent(uuid)}/settings`, {
            sectionKey,
            values,
            expectedRevision
        });
        return res.data;
    } catch (err) {
        return {
            success: false,
            error: err?.response?.data?.error || { message: "Unable to save product settings." }
        };
    }
};

export const retryLifecycle = ({ uuid, operationId }) => async () => {
    try {
        const res = await api.post(`/products/me/${encodeURIComponent(uuid)}/lifecycle/retry`, { operationId });
        return res.data;
    } catch (err) {
        return {
            success: false,
            error: err?.response?.data?.error || { message: "Unable to retry product setup." }
        };
    }
};

export const repairLifecycle = ({ uuid }) => async () => {
    try {
        const res = await api.post(`/products/me/${encodeURIComponent(uuid)}/lifecycle/provision`);
        return res.data;
    } catch (err) {
        return {
            success: false,
            error: err?.response?.data?.error || { message: "Unable to restart product setup." }
        };
    }
};

const productManagementFailure = (err, fallback) => ({
    success: false,
    error: err?.response?.data?.error || { message: fallback }
});

export const productManagement = ({ uuid }) => async () => {
    try {
        const res = await api.get(`/products/me/${encodeURIComponent(uuid)}/management`);
        return res.data;
    } catch (err) {
        return productManagementFailure(err, "Unable to load product management access.");
    }
};

export const searchProductManagers = ({ uuid, query }) => async () => {
    try {
        const res = await api.get(`/products/me/${encodeURIComponent(uuid)}/management/search`, { params: { query } });
        return res.data;
    } catch (err) {
        return productManagementFailure(err, "Unable to search Feradel users.");
    }
};

export const addProductManager = ({ uuid, personUuid, email, firstName, lastName }) => async () => {
    try {
        const res = await api.post(`/products/me/${encodeURIComponent(uuid)}/managers`, {
            personUuid,
            email,
            firstName,
            lastName,
            role: "ProductManager"
        });
        return res.data;
    } catch (err) {
        return productManagementFailure(err, "Management access could not be updated.");
    }
};

export const inviteProductManager = ({ uuid, email }) => async () => {
    try {
        const res = await api.post(`/products/me/${encodeURIComponent(uuid)}/management/invitations`, {
            email,
            role: "ProductManager"
        });
        return res.data;
    } catch (err) {
        return productManagementFailure(err, "The product-management invitation could not be created.");
    }
};

export const acceptProductManagerInvitation = ({ uuid, invitationUuid }) => async () => {
    try {
        const res = await api.post(`/products/me/${encodeURIComponent(uuid)}/management/invitations/${encodeURIComponent(invitationUuid)}/accept`);
        return res.data;
    } catch (err) {
        return productManagementFailure(err, "The product-management invitation could not be accepted.");
    }
};

export const removeProductManager = ({ uuid, personUuid }) => async () => {
    try {
        const res = await api.delete(`/products/me/${encodeURIComponent(uuid)}/managers/${encodeURIComponent(personUuid)}`);
        return res.data;
    } catch (err) {
        return productManagementFailure(err, "Management access could not be updated.");
    }
};

export const changeProductManagerRole = ({ uuid, personUuid }) => async () => {
    try {
        const res = await api.patch(`/products/me/${encodeURIComponent(uuid)}/managers/${encodeURIComponent(personUuid)}`, {
            role: "ProductManager"
        });
        return res.data;
    } catch (err) {
        return productManagementFailure(err, "The product manager role could not be changed.");
    }
};

export const resendProductManagerInvitation = ({ uuid, invitationUuid }) => async () => {
    try {
        const res = await api.post(`/products/me/${encodeURIComponent(uuid)}/management/invitations/${encodeURIComponent(invitationUuid)}/resend`);
        return res.data;
    } catch (err) {
        return productManagementFailure(err, "The invitation could not be resent.");
    }
};

export const revokeProductManagerInvitation = ({ uuid, invitationUuid }) => async () => {
    try {
        const res = await api.delete(`/products/me/${encodeURIComponent(uuid)}/management/invitations/${encodeURIComponent(invitationUuid)}`);
        return res.data;
    } catch (err) {
        return productManagementFailure(err, "The invitation could not be revoked.");
    }
};

export const updateInternalTag = ({ uuid, tag }) => async () => {
    try {
        const res = await api.patch(`/products/me/${encodeURIComponent(uuid)}/internal-tag`, { tag });
        return res.data;
    } catch (err) {
        return productManagementFailure(err, "The internal tag could not be updated.");
    }
};

export const share = ({ uuid, email = "X", personUuid = "X", firstName = "", lastName = "", flags = 0 }) => async (dispatch) => {
    try {
        // /df/:dateFrom/dt/:dateTo/a/:assignedToUuid/e/:eventUuid
        const res = await api.put(`/products/me/share`, { uuid, email, personUuid, flags, firstName, lastName });

        if (res?.data) {
            dispatch({
                type: SET_PROFILE_PRODUCT_SHARE,
                payload: res.data
            });
        }
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
};

export const shares = ({ uuid = "X", page = 0, size = 25, order = "email", direction = "ASC", raw = 1, search = ""}) => async (dispatch) => {
    try {
        // /df/:dateFrom/dt/:dateTo/a/:assignedToUuid/e/:eventUuid
        const res = await api.get(`/products/me/shares/l/i/${uuid}/p/${page}/s/${size}/o/${order}/${direction}/${raw}/${search}`);

        if (res?.data) {
            dispatch({
                type: GET_PROFILE_PRODUCT_SHARES,
                payload: res.data?.rows
            });
        }
        return res.data?.rows;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
};


export const unshare = ({ uuid, personUuid }) => async (dispatch) => {
    try {
        const res = await api.delete(`/products/me/share/${uuid}/${personUuid}`);

        if (res?.data) {
            dispatch({
                type: SET_PROFILE_PRODUCT_SHARE,
                payload: res.data
            });
        }
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
};

export const change = ({ uuid, productUuid }) => async () => {
    try {
        const res = await api.put(`/products/me/change/${uuid}`, { productUuid });
        if (res.data.success && res.data.change?.uuid) {
            const res_change = await api.post("/utility/process/changes", { uuid: res.data.change?.uuid });
            res.data.processed = Boolean(res_change?.data?.processed > 0);
        }
        return res.data;
    } catch (err) {
        return {
            success: false,
            error: err?.response?.data?.error || {
                message: "Unable to change this license."
            }
        };
    }
};

export const create = ({ charge, price, productUuid, modifiers, lines}) => async (dispatch) => {
    try {
        const res = await api.post(`/products/me/create`, { charge, price, productUuid, modifiers, lines });
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
};

export const checkout = ({ productUuid, code }) => async () => {
    try {
        const res = await api.post("/stripe/me/checkout", { productUuid, code });
        return res.data;
    } catch (err) {
        return {
            success: false,
            error: err?.response?.data?.error || {
                message: "Unable to prepare checkout."
            }
        };
    }
};

export const checkoutStatus = ({ sessionId, orderUuid }) => async () => {
    try {
        const path = sessionId
            ? `/stripe/me/checkout/session/${encodeURIComponent(sessionId)}`
            : `/stripe/me/checkout/order/${encodeURIComponent(orderUuid)}`;
        const res = await api.get(path);
        return res.data;
    } catch (err) {
        return {
            success: false,
            error: err?.response?.data?.error || {
                message: "Unable to confirm checkout."
            }
        };
    }
};

export const estimateOrder = ({ selections, existingLicenseId = null }) => async () => {
    try {
        const res = await api.post("/stripe/me/order/estimate", {
            selections,
            ...(existingLicenseId ? { existingLicenseId } : {})
        });
        return res.data;
    } catch (err) {
        return {
            success: false,
            error: err?.response?.data?.error || {
                message: "We could not calculate the order total."
            }
        };
    }
};

/*
export const transfer = ({ uuid, personUuid }) => async (dispatch) => {
    try {
        // /df/:dateFrom/dt/:dateTo/a/:assignedToUuid/e/:eventUuid
        const res = await api.put(`/licensees/me/transfer`, { licenseeProductUuid: uuid, contactUuid: personUuid });

        if (res?.data) {
            dispatch({
                type: SET_PROFILE_PRODUCT_SHARE,
                payload: res.data
            });
        }
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
};
*/
